import { SxProps, Theme } from '@mui/material';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';
import React from 'react';

import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';
import { Project } from '~hooks/useProjects/models';

interface ProjectResponsibleAndIdProps {
  project: Project;
  sx?: SxProps<Theme>;
}

export default function ProjectResponsibleAndId({
  project,
  sx,
}: ProjectResponsibleAndIdProps) {
  const nodes: React.ReactNode[] = [];

  if (project.foremen.length) {
    const foremanNames = project.foremen.map((foreman) => foreman.fullName).join(', ');
    nodes.push(
      <Typography component="span" sx={{ color: 'inherit', fontSize: 'inherit' }}>
        {`${t('form_fields.assigned_foreman')}: ${foremanNames}`}
      </Typography>,
    );
  }

  const salespeopleCount = project.salespeople.length;

  if (salespeopleCount) {
    nodes.push(
      <Typography component="span" sx={{ color: 'inherit', fontSize: 'inherit' }}>
        {`${t('form_fields.sales')}: ${project.salespeople[0].fullName}${salespeopleCount > 1 ? ` +${salespeopleCount}` : ''}`}
      </Typography>,
    );
  } else if (project.requester?.fullName) {
    nodes.push(
      <Typography component="span" sx={{ color: 'inherit', fontSize: 'inherit' }}>
        {`${t('dispatch.dispatch_v3.requestor')}: ${project.requester.fullName}`}
      </Typography>,
    );
  }

  nodes.push(project.projectId);

  return (
    <OverflowAwareText
      sx={[
        (theme) => ({ color: theme.brandV2.colors.treadGray3, fontSize: '10px' }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {nodes.map((node, index) => (
        <React.Fragment key={index}>
          {node}

          {nodes.length - 1 !== index && (
            <Typography
              component="span"
              sx={{ color: 'inherit', fontSize: 'inherit', mx: 0.5 }}
            >
              {'•'}
            </Typography>
          )}
        </React.Fragment>
      ))}
    </OverflowAwareText>
  );
}
